const FeaturedSection = () => {
  return (
    <section className="featured-section">
      <div className="container">
        <div className="featured-section__main">
          <div className="featured-section__header">
            <div className="featured-section__header-line"></div>
            <h3 className="featured-section__heading">Featured on</h3>
            <div className="featured-section__header-line"></div>
          </div>
          <div className="featured-section__featured">
            <a
              href="https://markets.businessinsider.com/news/stocks/sekiapp-redefining-financial-freedom-and-security-in-the-nigerian-cryptocurrency-market-1033237057"
              target="_blank"
              rel="noreferrer"
              className="featured-section__feature"
            >
              <svg
                className="svg-icon logo-BI-icon logo-vertically-center-icon"
                aria-labelledby="title desc"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                width="103"
                height="32"
                viewBox="0 0 103 32"
              >
                <title id="title">Business Insider logo</title>
                <desc id="desc">The words "Business Insider".</desc>

                <g
                  className="logo-BI logo-vertically-center-icon-fill"
                  fill="currentColor"
                  fill-rule="evenodd"
                >
                  <path d="M7.984 32h2.396V19.2H7.984zM16.767 31.808h2.146v-8.076L27.946 32V19.392h-2.14v7.938l-9.039-8.13zM32.845 28.708c1.168.91 2.57 1.436 4.073 1.436 1.464 0 2.491-.504 2.491-1.617 0-.97-.655-1.35-1.802-1.775l-1.857-.645c-1.712-.608-3.014-1.496-3.014-3.537 0-2.183 1.971-3.37 4.328-3.37 1.444 0 2.76.363 3.788 1.006v2.165c-1.069-.79-2.239-1.334-3.742-1.334-1.294 0-2.261.483-2.261 1.49 0 .91.607 1.274 1.676 1.64l2.069.726c2.005.705 2.925 1.798 2.925 3.596 0 2.262-1.99 3.511-4.601 3.511-1.716 0-3.175-.48-4.073-1.086v-2.206zM47.109 32h2.395V19.2h-2.395zM60.74 30.063c2.7 0 4.143-1.732 4.143-4.466 0-2.754-1.444-4.48-4.143-4.48h-2.67v8.946h2.67zM55.89 19.2h4.93c3.795 0 6.249 2.5 6.249 6.397 0 3.9-2.454 6.403-6.249 6.403h-4.93V19.2zM79.047 19.2v1.917H73.25v3.08h5.199v1.895h-5.2v3.971h5.798V32h-7.985V19.2zM87.549 24.996h2.377c1.407 0 2.2-.772 2.2-1.959s-.793-1.96-2.2-1.96h-2.377v3.92zm0 1.81V32h-2.115V19.2h4.532c2.584 0 4.256 1.331 4.256 3.837 0 2.143-.928 3.374-2.905 3.69L95.814 32h-2.406l-4.354-5.193H87.55zM7.147 6.59c.937-.343 1.667-1.372 1.667-2.787 0-2.358-1.667-3.58-4.334-3.58H0v13.163h4.896c2.667 0 4.334-1.308 4.334-3.773 0-1.394-.875-2.616-2.083-3.023zm-5.043-.836V2.153H4.46c1.48 0 2.271.536 2.271 1.779 0 1.243-.792 1.822-2.271 1.822H2.104zm0 1.844h2.75c1.46 0 2.251.728 2.251 1.929 0 1.179-.792 1.93-2.25 1.93h-2.75v-3.86zM19.005 13.6c3.063 0 5.126-1.844 5.126-5.445V.223h-2.167v7.674c0 2.53-1.042 3.71-2.959 3.71s-2.958-1.18-2.958-3.71V.223H13.88v7.91c0 3.623 2.083 5.467 5.125 5.467zm10.228-1.158c.896.644 2.355 1.158 4.063 1.158 2.605 0 4.584-1.33 4.584-3.73 0-1.908-.916-3.066-2.917-3.816l-2.062-.772c-1.063-.385-1.667-.771-1.667-1.736 0-1.072.958-1.586 2.25-1.586 1.5 0 2.667.578 3.73 1.415V1.08C36.193.395 34.88.009 33.442.009c-2.354 0-4.313 1.265-4.313 3.58 0 2.165 1.292 3.108 3 3.751l1.855.686c1.146.45 1.792.858 1.792 1.887 0 1.179-1.021 1.715-2.48 1.715-1.5 0-2.896-.558-4.063-1.522v2.336zM45.623.223h-2.166v13.162h2.166V.223zm6.182 13.146h2.088V4.806l8.788 8.767V.203h-2.082V8.62L51.805 0v13.369zM76.222.226v1.971h-5.626v3.168h5.045v1.949h-5.045v4.083h5.626v1.992h-7.75V.226h7.75zm5.045 12.207c.896.644 2.354 1.158 4.063 1.158 2.604 0 4.584-1.329 4.584-3.73 0-1.908-.917-3.065-2.917-3.816l-2.063-.771c-1.063-.386-1.667-.772-1.667-1.737 0-1.072.958-1.586 2.25-1.586 1.5 0 2.667.579 3.73 1.415V1.072C88.226.386 86.913 0 85.475 0c-2.354 0-4.313 1.265-4.313 3.58 0 2.165 1.292 3.108 3 3.751l1.855.686c1.146.45 1.792.858 1.792 1.887 0 1.179-1.02 1.715-2.48 1.715-1.5 0-2.896-.557-4.062-1.522v2.336zm13.086 0c.896.644 2.355 1.158 4.063 1.158 2.605 0 4.584-1.329 4.584-3.73 0-1.908-.917-3.065-2.917-3.816l-2.063-.771c-1.062-.386-1.667-.772-1.667-1.737 0-1.072.959-1.586 2.25-1.586 1.5 0 2.668.579 3.73 1.415V1.072C101.313.386 100 0 98.562 0c-2.355 0-4.313 1.265-4.313 3.58 0 2.165 1.292 3.108 3 3.751l1.855.686c1.146.45 1.792.858 1.792 1.887 0 1.179-1.021 1.715-2.48 1.715-1.5 0-2.896-.557-4.063-1.522v2.336z"></path>
                </g>
              </svg>
            </a>
            <a
              href="https://www.benzinga.com/pressreleases/24/04/38181860/sekiapp-redefining-financial-freedom-and-security-in-the-nigerian-cryptocurrency-market"
              target="_blank"
              rel="noreferrer"
              className="featured-section__feature"
            >
              <svg
                height="100%"
                role="img"
                viewBox="0 0 471.1 63.8"
                width="100%"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M67.7 63.8h45.2V51.9H81.4V37.3h26.1V25.4H81.4V11.9h31.7V0H67.7zm99.6-23.6L137.7 0h-20.4l6.4 8.1V64h13.6V22.1l30.6 41.7H181V0h-13.7zM47.1 31c6-1.1 11-6.7 11-14.6C58.1 7.9 51.9 0 39.6 0H0l6.2 7.9v56H41c12.3 0 18.7-7.7 18.7-17.3-.3-7.9-5.7-14.7-12.6-15.6zM19.8 12h17.1c4.6 0 7.5 2.7 7.5 6.7s-2.9 6.7-7.5 6.7H19.8V12zm17.7 40H19.8V37.3h17.7c5.2 0 8.1 3.3 8.1 7.3 0 4.6-3.1 7.3-8.1 7.4zm343.3-11.8h7.1v7.5c-3.7 3-8.3 4.7-13.1 4.8-11.4 0-19.4-8.7-19.4-20.4s8.1-20.4 19.4-20.4c5.9 0 11.4 3.1 14.6 8.1l10.8-6C395.6 6.5 387.5 0 374.7 0c-18.1 0-33.1 12.5-33.1 31.9s14.8 31.9 33.1 31.9c10 .2 19.5-4.1 26.1-11.5V28.7h-29.2l9.2 11.5zm-61.5 0L289.6 0h-20.3l6.3 8.1V64h13.7V22.1l30.6 41.7h13V0h-13.6zM446 0h-26.3l6.3 8.1-1.1 3.1L404.5 64h15.4l4-10.8h27.5l4 10.8h15.4L446 0zm-18.6 41.2l10-27.5 10 27.5h-20zM247.7 0h13.7v64.1h-13.7zm-10.9 11V0h-48.1v11.9h30.2l-30.2 41v10.9h48.6V51.9h-30.9z"
                  fill="currentColor"
                ></path>
              </svg>
            </a>
            {/* <a
              href="https://www.theglobeandmail.com/investing/markets/markets-news/Plentisoft/25386788/sekiapp-redefining-financial-freedom-and-security-in-the-nigerian-cryptocurrency-market/"
              target="_blank"
              rel="noreferrer"
              className="featured-section__feature"
              dangerouslySetInnerHTML={{
                __html: `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="232.02475mm"
   height="26.45833mm"
   viewBox="0 0 232.02475 26.45833"
   version="1.1"
   id="svg5774"
   inkscape:version="0.92.1 r15371"
   sodipodi:docname="The_Globe_and_Mail_(2019-10-31).svg">
  <defs
     id="defs5768" />
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.35"
     inkscape:cx="438.47196"
     inkscape:cy="50"
     inkscape:document-units="mm"
     inkscape:current-layer="layer1"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:window-width="1920"
     inkscape:window-height="1001"
     inkscape:window-x="-9"
     inkscape:window-y="-9"
     inkscape:window-maximized="1" />
  <metadata
     id="metadata5771">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Ebene 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(220.3338,-135.60417)">
    <path
       style="clip-rule:nonzero;fill:transparent;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.35900429"
       d="M -220.3338,135.60417 H 11.690946 V 162.0625 H -220.3338 v -26.45833"
       id="path3642"
       inkscape:connector-curvature="0" />
    <path
       inkscape:connector-curvature="0"
       id="path3646"
       d="m 7.1879664,145.65909 c 0.50064,-0.31974 0.82459,-0.75727 0.79514,-0.90452 -0.087,-0.11079 -0.2945,-0.0856 -0.55674,0.0617 -0.2945,0.14304 -0.67734,0.0575 -0.88489,-0.26645 -0.20334,-0.32254 -0.4151,-0.26224 -0.67734,-0.0533 -0.26364,0.20054 -0.79374,0.49504 -1.03214,0 -0.14724,-0.55673 -0.0911,-0.40949 0.32395,-1.17377 0.4151,-0.76148 0.50064,-1.37151 0.50064,-1.49071 0,-0.11499 -0.0561,-0.1753 -0.44034,0 -0.32395,0.087 -0.3534,-1.5468 -0.38425,-1.7838 0,0 0,-0.43754 -0.26364,-0.0575 -0.20615,0.26645 -1.03074,1.05177 -1.29859,1.14152 -0.25803,0.087 -0.64228,-0.14725 -0.58618,-0.46698 0,-0.32255 -0.20756,-0.20755 -0.2973,0 -0.087,0.20194 -0.7082,2.19048 -0.85124,2.30828 -0.15005,0.11499 -0.26785,0.40949 -0.53009,-0.0855 -0.26363997,-0.50205 -0.72921997,-1.68003 -1.16115997,-1.09805 -0.11639,-0.11219 -0.87226003,-1.1275 -1.48930003,-1.15695 -0.0912,0.1192 0.0561,0.40949 0.17669,0.49924 0.1164,0.14444 0.1164,0.55674 0,0.84422 -0.1206,0.2945 -0.1206,0.67454 0.0308,1.02653 0.0855,0.1753 -0.0308,0.46699 -0.53571,0.52729 -0.49643,0.0575 -0.40948,0.20194 -0.20194,0.46278 0.20194,0.26645 0.97044,0.90873 1.14713,1.14292 0.17249003,0.237 -0.0294,0.52308 -0.38424,0.55253 -0.3534,0.0323 -0.67314,-0.087 -0.76289,0.12201 -0.0308,0.20474 0.26224,0.11499 0.38425,0.29028 0,0 0.64649,1.16677 1.50052003,1.11348 0.85124,-0.0575 0.8891,0.0505 0.79515,0.40949 -0.087,0.30431 -0.7727,1.29578 -1.41639,1.37431 0,0 -0.28468003,-0.0855 -0.32254003,0.2342 -0.0182,0.13182 0.0294,0.24401 0.1809,0.36601 0.0294,0.021 0.0813,0.0393 0.12061003,0.0393 0.57356,0.0463 1.23828,-0.94379 1.67021,-1.68423 0.19492,-0.34078 0.27204997,-0.44876 0.36320997,-0.44876 0.0421,0 0.20194,-0.021 0.37443,0.29169 0.23279,0.40809 1.41638,1.58186 2.91691,1.25932 0.0603,-0.14725 -0.20615,-0.26504 -0.38425,-0.3548 0,0 -0.61704,-0.49643 0.1781,-0.72502 0.79374,-0.1795 1.17798,0.11079 1.85533,-0.43893 0.0294,-0.17951 -0.3534,-0.26926 -0.3534,-0.26926 0,0 -0.47119,-0.28748 0.91013,-0.69557 0.67734,-0.1795 0.67734,-0.29449 0.56515,-0.38144 -0.122,-0.0897 -0.44455,-0.20755 0.0253,-0.5315 z m -168.1542464,5.63749 h 1.69686 v 4.53383 c -0.56655,0.16828 -1.17939,0.34077 -1.8427,0.34077 -2.30969,0 -3.85369,-1.73051 -3.85369,-7.55732 0,-3.82704 0.97885,-7.26282 3.80601,-7.26282 2.06146,0 2.80051,1.75576 3.53395,4.53523 l 1.18219,-0.26925 v -4.39079 c -0.49223,-0.31693 -2.04184,-0.948 -4.76803,-0.948 -4.56609,0 -7.34135,4.48335 -7.34135,8.79841 0,5.58 3.19457,8.26131 7.24599,8.26131 0.98025,0 2.74863,-0.38705 3.75412,-0.72923 l 1.52436,-0.1178 v -6.07502 h -4.93771 v 0.88068"
       style="fill:currentColor;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.35900429" />
    <path
       inkscape:connector-curvature="0"
       id="path3648"
       d="m -145.83621,154.51219 c -0.4179,1.24249 -0.88349,1.65899 -1.8427,1.65899 h -2.42889 c 0.0982,-0.14724 0.0982,-1.78099 0.0982,-14.74722 h 1.83849 v -0.88068 h -6.87436 v 0.88068 h 1.69685 v 14.74722 h -1.76978 v 0.87928 h 10.87951 l 0.36602,-5.26586 c -0.36602,-0.0477 -0.66051,-0.0477 -1.03074,-0.10097 z m 9.28082,1.68424 c -1.56223,0 -3.51992,-1.29298 -3.51992,-7.41288 0,-5.5828 1.43461,-7.35959 3.51992,-7.35959 1.41218,0 3.54938,0.87508 3.54938,7.40867 0,5.87449 -1.74734,7.3638 -3.54938,7.3638 z m 0,-15.9182 c -5.05972,0 -7.27404,4.07106 -7.27404,8.72409 0,5.5856 2.99825,8.33563 7.27404,8.33563 5.06533,0 7.3063,-4.07105 7.3063,-8.72409 0,-5.24062 -2.74021,-8.33563 -7.3063,-8.33563"
       style="fill:currentColor;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.35900429" />
    <path
       inkscape:connector-curvature="0"
       id="path3650"
       d="m -122.42941,156.17118 h -1.67442 c -0.2412,0 -0.2412,-0.22297 -0.2412,-0.55954 v -6.535 h 1.93806 c 1.59589,0 2.08812,1.53419 2.08812,3.60828 0,2.851 -0.95782,3.48626 -2.11056,3.48626 z m -1.91983,-14.74722 h 1.7221 c 1.22566,0 2.18347,0.97605 2.18347,3.63212 0,1.6085 -0.66051,2.99824 -1.83849,2.99824 h -2.06708 z m 3.88454,7.1899 v -0.14724 c 1.8413,-0.5343 3.19318,-2.29006 3.19318,-3.65736 0,-2.65747 -1.84411,-4.26598 -5.33038,-4.26598 h -6.85193 v 0.87648 h 1.74313 v 14.75142 h -1.74313 v 0.87928 h 6.99918 c 3.48627,0 5.54914,-1.78099 5.54914,-4.3403 0,-1.97452 -1.49772,-3.63352 -3.55919,-4.0963 z m 14.41346,5.92077 c -0.34217,1.10226 -0.88489,1.63655 -1.76557,1.63655 h -3.34042 c 0,-0.55954 0,-2.24377 0.0224,-3.75552 0,-0.9508 0.0252,-2.68131 0.0252,-2.94776 h 4.25055 v -1.3673 h -4.25054 v -6.67664 h 2.60138 c 0.91153,0 1.30419,0.34078 1.57625,1.19061 l 0.85825,2.90148 c 0.36742,-0.0463 0.68575,-0.0463 1.07841,-0.0968 v -4.87601 h -11.00007 v 0.88068 h 1.54541 v 14.74722 h -2.11056 v 0.87928 h 12.10518 l 0.17249,-5.09758 -1.07841,-0.19352 z m 40.035986,1.63655 c -0.39126,0 -0.56515,-0.26925 -0.56515,-0.73623 v -14.01099 c 3.51291,0 5.4033,2.19329 5.4033,7.35959 0,5.33738 -1.49773,7.38763 -4.83815,7.38763 z m -28.8101,-6.21385 1.74454,-6.07503 1.74314,6.07503 z m 29.49726,-9.41405 h -11.3465 v 0.88068 c 1.74453,0 2.03763,0.46278 2.03763,1.3631 v 8.21783 c -2.11056,-3.48627 -4.19867,-6.9501 -6.28819,-10.46161 h -4.34591 v 0.78252 c 0.7124,0.22017 1.22706,0.75447 1.64497,1.28877 v 11.92006 c 0,1.41358 -0.73905,1.61131 -1.49772,1.63655 h -0.81057 l -4.8115,-15.6279 h -2.28444 c -0.61704,2.48779 -4.25196,13.7249 -4.25196,13.7249 -0.34498,1.04897 -0.91153,1.92404 -1.98995,1.92404 h -0.0266 v 0.85544 h 5.28549 v -0.87648 h -0.14725 c -1.45144,-0.122 -1.89599,-0.14724 -1.89599,-1.19481 0,-0.31973 0.0252,-0.68295 0.12481,-1.17097 l 0.85965,-2.97581 h 4.00654 l 1.5454,5.34159 h -1.81746 v 0.87928 h 11.052 v -0.85403 c -2.03762,-0.0505 -2.16243,-0.61424 -2.16243,-1.63375 v -10.21339 c 2.55509,4.23933 5.06252,8.48287 7.63865,12.70117 h 1.30279 v -14.2634 c 0,-1.07281 0.66052,-1.34206 1.86515,-1.3631 h 1.69545 v 14.74722 h -1.84271 v 0.87928 h 6.68085 c 4.86339,0 7.68494,-3.82984 7.68494,-8.46184 0.006,-4.70632 -3.21421,-8.04534 -7.90511,-8.04534 z m 34.77433,9.41405 1.74314,-6.07503 1.74734,6.07503 z m 9.94694,-8.53337 h 1.54821 v 14.74722 h -2.60138 l -4.8171,-15.6279 h -2.28165 c -0.61283,2.48779 -4.25055,13.7249 -4.25055,13.7249 -0.31553,0.96623 -0.8288,1.781 -1.75155,1.903 h -1.29158 l -0.88488,-14.74722 h 1.89038 v -0.88068 h -5.18313 l -3.14129,8.77878 c -1.03213,-2.90149 -2.11475,-5.87449 -3.095,-8.77878 h -5.48043 v 0.88068 c 1.69546,0 1.82167,0.26926 1.82167,1.8988 v 0.17249 c -0.14725,2.92532 -0.46559,8.36087 -0.68996,11.43344 -0.0491,0.68295 -0.61283,1.24249 -2.08532,1.31402 v 0.80775 h 5.817 v -0.85403 c -2.08391,-0.0505 -2.40365,-0.75447 -2.40365,-1.26774 0,-0.29449 0.0729,-2.4373 0.14725,-4.48755 0.0996,-2.8496 0.19493,-4.70211 0.29309,-7.6036 v 0.12201 c 1.40236,3.94624 2.90008,7.96961 4.29823,11.91866 l 0.53992,-0.24401 c 1.37711,-3.73028 2.72759,-7.31191 4.12574,-11.01695 l 0.63807,12.55393 h -1.61832 v 0.87928 h 11.31985 v -0.87928 h -0.14724 c -1.45004,-0.122 -1.89038,-0.14724 -1.89038,-1.19481 0,-0.31973 0.0266,-0.68295 0.122,-1.17097 l 0.86246,-2.97581 h 3.99952 l 1.55101,5.34159 h -1.82166 v 0.87928 h 13.11487 v -0.87928 h -1.52015 v -14.74722 h 1.52436 v -0.88068 h -6.65841 z m 16.7526004,13.08823 c -0.41931,1.24249 -0.8905,1.65899 -1.8427,1.65899 h -2.4345 c 0.0996,-0.14724 0.0996,-1.77679 0.0996,-14.74722 h 1.8427 v -0.88068 h -6.8785804 v 0.88068 h 1.69545 v 14.74722 h -1.76977 v 0.87928 h 10.8795104 l 0.37163,-5.26586 c -0.37163,-0.0547 -0.66472,-0.0547 -1.03214,-0.10097 z M -188.15384,141.42396 h 1.69686 v -0.88068 h -6.70328 v 0.88068 h 1.6674 v 6.74816 h -5.03307 v -6.74816 h 1.69265 v -0.88068 h -20.40855 l -0.17249,4.92649 c 0.39266,0.021 0.7124,0.0968 1.10506,0.12201 l 0.86245,-3.12025 c 0.24681,-0.90172 0.53991,-1.04757 1.52436,-1.04757 h 1.71649 v 14.74722 h -2.30828 v 0.87928 h 7.98364 v -0.87928 h -2.33493 v -14.74722 h 1.76978 c 1.05317,0 1.22566,0.21456 1.47107,1.04757 l 0.85825,3.12025 c 0.39406,-0.0252 0.7124,-0.10097 1.10506,-0.12201 v -4.04581 h 1.79642 v 14.74722 h -1.89038 v 0.87928 h 6.92205 v -0.87928 h -1.69265 v -6.72712 h 5.03307 v 6.72712 h -1.6674 v 0.87928 h 6.71309 v -0.87928 h -1.70667 v -14.74722"
       style="fill:currentColor;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.35900429" />
    <path
       inkscape:connector-curvature="0"
       id="path3652"
       d="m -175.69947,154.53463 c -0.34498,1.10226 -0.88489,1.63655 -1.76838,1.63655 h -3.34042 c 0,-0.55954 0,-2.24377 0.0266,-3.75552 0,-0.9508 0.0252,-2.68131 0.0252,-2.94776 h 4.24635 v -1.3673 h -4.24632 v -6.67664 h 2.60138 c 0.90733,0 1.29999,0.34078 1.57065,1.19061 l 0.85964,2.90148 c 0.37163,-0.0463 0.68997,-0.0463 1.08263,-0.0968 v -4.87601 h -11.00433 v 0.88068 h 1.5454 v 14.74722 h -1.55662 v 0.87928 h 11.55545 l 0.17249,-5.09758 -1.08262,-0.19352 -0.68715,2.77527"
       style="fill:currentColor;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.35900429" />
  </g>
</svg>
`,
              }}
            /> */}
            <a
              href="https://www.barchart.com/story/news/25386773/sekiapp-redefining-financial-freedom-and-security-in-the-nigerian-cryptocurrency-market"
              target="_blank"
              rel="noreferrer"
              className="featured-section__feature"
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="612px"
                height="118.97px"
                viewBox="0 335.863 612 118.97"
                enable-background="new 0 335.863 612 118.97"
              >
                <title>bc-logo</title>
                <path
                  fill="currentColor"
                  d="M20.428,335.863v40.855c3.434-3.557,7.545-6.392,12.09-8.338c4.369-1.805,9.032-2.794,13.758-2.918
	c10.478-0.089,20.494,4.312,27.515,12.09c7.605,8.604,11.633,19.791,11.256,31.267c0.348,11.424-3.85,22.519-11.673,30.851
	c-6.965,7.906-16.979,12.458-27.515,12.507c-4.565,0.017-9.092-0.832-13.341-2.502c-4.545-1.945-8.656-4.78-12.09-8.338v8.755H0
	V335.863H20.428z M42.106,384.64c-6.138-0.282-12.087,2.159-16.259,6.67c-4.257,4.816-6.496,11.086-6.253,17.509
	c-0.313,6.56,1.929,12.984,6.253,17.927c4.171,4.511,10.121,6.951,16.259,6.67c6.06,0.053,11.842-2.534,15.842-7.087
	c4.382-4.769,6.769-11.034,6.67-17.51c0.297-6.494-1.946-12.849-6.253-17.718C54.052,386.823,48.18,384.489,42.106,384.64z"
                />
                <path
                  fill="currentColor"
                  d="M158.419,367.964h20.845v82.545h-20.845v-8.755c-3.51,3.467-7.602,6.289-12.09,8.338
	c-4.238,1.708-8.772,2.558-13.34,2.502c-10.574,0.124-20.656-4.459-27.515-12.507c-7.887-8.292-12.096-19.415-11.673-30.851
	c-0.522-11.499,3.524-22.739,11.256-31.267c6.906-7.937,16.998-12.371,27.515-12.09c4.751-0.123,9.465,0.877,13.757,2.918
	c4.545,1.946,8.656,4.781,12.09,8.338V367.964z M136.741,384.64c-6.002-0.203-11.792,2.235-15.842,6.67
	c-4.257,4.816-6.496,11.086-6.253,17.509c-0.243,6.423,1.997,12.693,6.253,17.51c8.336,8.974,22.37,9.491,31.344,1.154
	c0.258-0.24,0.51-0.485,0.756-0.737c4.324-4.942,6.566-11.367,6.253-17.927c0.243-6.423-1.997-12.693-6.253-17.509
	C148.722,386.955,142.845,384.544,136.741,384.64z"
                />
                <path
                  fill="currentColor"
                  d="M194.272,367.964h17.926v10.631c1.699-3.634,4.278-6.787,7.504-9.172c3.051-2.151,6.689-3.315,10.422-3.335
	c2.888,0.146,5.72,0.854,8.338,2.084l-6.253,17.926c-1.8-0.977-3.792-1.546-5.837-1.667c-3.545,0.255-6.627,2.526-7.921,5.836
	c-2.084,3.752-3.335,11.673-3.335,23.346v37.521h-20.428v-83.17H194.272z"
                />
                <path
                  fill="currentColor"
                  d="M322.676,384.64l-17.093,9.588c-2.659-3.013-5.927-5.429-9.588-7.087c-3.584-1.409-7.405-2.116-11.256-2.084
	c-6.959-0.302-13.739,2.259-18.76,7.087c-4.745,4.735-7.312,11.228-7.087,17.927c-0.224,6.455,2.361,12.689,7.087,17.093
	c11.964,9.917,29.623,8.63,40.022-2.919l16.259,11.257c-8.755,11.673-21.262,17.093-37.521,17.093
	c-14.591,0-25.847-4.169-34.185-12.924c-8-7.94-12.502-18.745-12.507-30.017c0.005-7.745,2.016-15.358,5.836-22.095
	c4.038-6.681,9.797-12.152,16.676-15.842c7.448-3.928,15.76-5.935,24.18-5.836c7.659-0.123,15.236,1.592,22.096,5.003
	C313.361,373.796,318.875,378.585,322.676,384.64z"
                />
                <path
                  fill="currentColor"
                  d="M333.098,335.863h20.428v40.438c3.626-3.211,7.698-5.88,12.091-7.921c3.969-1.631,8.216-2.48,12.507-2.501
	c7.781-0.111,15.286,2.89,20.845,8.338c5.002,5.003,7.087,12.09,7.087,21.678v54.613h-20.428v-36.27
	c0.215-6.557-0.204-13.118-1.251-19.594c-0.548-2.982-2.182-5.656-4.586-7.504c-2.417-1.751-5.355-2.633-8.338-2.501
	c-4.031-0.15-7.947,1.356-10.839,4.169c-3.041,3.135-5.198,7.018-6.254,11.256c-0.666,5.672-0.945,11.383-0.834,17.093v33.352
	h-20.428V335.863z"
                />
                <path
                  fill="currentColor"
                  d="M480.679,367.964h20.845v82.545h-20.845v-8.755c-3.51,3.467-7.603,6.289-12.09,8.338
	c-4.238,1.708-8.772,2.558-13.341,2.502c-10.574,0.124-20.656-4.459-27.515-12.507c-7.888-8.292-12.097-19.415-11.674-30.851
	c-0.521-11.499,3.524-22.739,11.257-31.267c6.906-7.937,16.998-12.371,27.515-12.09c4.752-0.123,9.465,0.877,13.758,2.918
	c4.545,1.946,8.655,4.781,12.09,8.338V367.964z M459,384.64c-6.003-0.203-11.793,2.235-15.842,6.67
	c-4.257,4.816-6.496,11.086-6.254,17.509c-0.242,6.423,1.997,12.693,6.254,17.51c8.337,8.974,22.37,9.491,31.344,1.154
	c0.259-0.24,0.511-0.485,0.757-0.737c4.324-4.942,6.565-11.367,6.254-17.927c0.242-6.423-1.997-12.693-6.254-17.509
	C470.891,387.09,465.073,384.704,459,384.64L459,384.64z"
                />
                <path
                  fill="currentColor"
                  d="M516.948,367.964h17.927v10.631c1.698-3.634,4.278-6.787,7.504-9.172c3.051-2.151,6.688-3.315,10.422-3.335
	c2.889,0.146,5.721,0.854,8.338,2.084l-6.253,17.926c-1.8-0.977-3.792-1.546-5.837-1.667c-3.545,0.255-6.627,2.526-7.921,5.836
	c-2.084,3.752-3.335,11.673-3.335,23.346v37.521h-20.428v-83.17H516.948z"
                />
                <path
                  fill="currentColor"
                  d="M579.065,337.531h20.845v30.433H612v17.926h-12.09v64.619h-20.845v-65.035h-10.423v-17.51h10.423V337.531z"
                />
              </svg>
            </a>
            <a
              href="https://pr.newsmax.com/article/SEKIAPP-Redefining-Financial-Freedom-and-Security-in-the-Nigerian-Cryptocurrency-Market?storyId=6616919d6fce8600081fbfbd"
              target="_blank"
              rel="noreferrer"
              className="featured-section__feature"
              dangerouslySetInnerHTML={{
                __html: ` <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                width="1000"
                height="154.813"
                viewBox="0 0 1000 154.81299"
                version="1.1"
                id="svg41344"
                sodipodi:docname="A.svg"
                inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
              >
                <metadata id="metadata41350">
                  <rdf:RDF>
                    <cc:Work rdf:about="">
                      <dc:format>image/svg+xml</dc:format>
                      <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                      <dc:title></dc:title>
                    </cc:Work>
                  </rdf:RDF>
                </metadata>
                <defs id="defs41348">
                  <linearGradient
                    inkscape:collect="always"
                    id="linearGradient45974"
                  >
                    <stop
                      style="stop-color:#b5000b;stop-opacity:1"
                      offset="0"
                      id="stop45970"
                    />
                    <stop
                      id="stop45978"
                      offset="0.2"
                      style="stop-color:#cc0011;stop-opacity:1"
                    />
                    <stop
                      style="stop-color:#e60017;stop-opacity:1"
                      offset="0.40000001"
                      id="stop45980"
                    />
                    <stop
                      id="stop45982"
                      offset="0.60000002"
                      style="stop-color:#fe001c;stop-opacity:1"
                    />
                    <stop
                      style="stop-color:#fe001c;stop-opacity:1"
                      offset="0.80000001"
                      id="stop45984"
                    />
                    <stop
                      style="stop-color:#fe001c;stop-opacity:1"
                      offset="1"
                      id="stop45972"
                    />
                  </linearGradient>
                  <clipPath clipPathUnits="userSpaceOnUse" id="clipPath42098">
                    <path
                      d="M 0,0 H 1405.984 V 841.89 H 0 Z"
                      id="path42096"
                      inkscape:connector-curvature="0"
                    />
                  </clipPath>
                  <linearGradient
                    inkscape:collect="always"
                    xlink:href="#linearGradient45974"
                    id="linearGradient45976"
                    x1="-64.933975"
                    y1="689.19647"
                    x2="-64.933975"
                    y2="627.15686"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(1.2699295,0,0,1.2699295,85.085274,-724.1646)"
                  />
                </defs>
                <sodipodi:namedview
                  pagecolor="#ffffff"
                  bordercolor="#111111"
                  borderopacity="1"
                  objecttolerance="10"
                  gridtolerance="10"
                  guidetolerance="10"
                  inkscape:pageopacity="0"
                  inkscape:pageshadow="2"
                  inkscape:window-width="1920"
                  inkscape:window-height="1017"
                  id="namedview41346"
                  showgrid="false"
                  fit-margin-top="0"
                  fit-margin-left="0"
                  fit-margin-right="0"
                  fit-margin-bottom="0"
                  inkscape:zoom="0.49665834"
                  inkscape:cx="748.37961"
                  inkscape:cy="-262.20918"
                  inkscape:window-x="1912"
                  inkscape:window-y="-8"
                  inkscape:window-maximized="1"
                  inkscape:current-layer="svg41344"
                >
                  <inkscape:grid
                    type="xygrid"
                    id="grid45951"
                    originx="67"
                    originy="523.93215"
                  />
                </sodipodi:namedview>
                <path
                  style="opacity:1;fill:url(#linearGradient45976);fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 34.288096,151.08932 H 0 V 72.3537 l 34.288096,54.69306 z"
                  id="path45953"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccccc"
                />
                <path
                  style="opacity:1;fill:currentColor;fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 34.288096,111.4686 0,55.84461 V 3.77751 h 40.185734 l 59.503729,96.51463 V 3.77751 H 133.34259 V 151.08932 H 93.97478 L 34.288096,54.57468 Z"
                  id="path45955"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccccccccccc"
                />
                <path
                  style="opacity:1;fill:currentColor;fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 144.77196,151.08932 V 3.77751 h 99.0545 v 29.84334 h -64.76641 v 28.57341 h 60.95662 v 27.93845 h -60.95662 v 31.11327 h 68.5762 v 29.84334 z"
                  id="path45957"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccccccccccccc"
                />
                <path
                  style="opacity:1;fill:currentColor;fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 287.79456,151.08932 250.0962,3.77751 h 33.88858 l 22.07677,88.1131 19.04039,-88.1131 h 39.36782 l 21.90841,88.1131 19.99926,-88.1131 h 34.28809 l -37.61846,147.31181 h -35.55802 l -21.89987,-95.2618 -22.71602,95.2618 z"
                  id="path45959"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="cccccccccccccc"
                />
                <path
                  style="opacity:1;fill:currentColor;fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="m 455.62217,110.05607 -23.1755,23.73366 c 0,0 17.93113,21.02328 55.26544,21.02328 34.54467,0 56.16209,-19.63645 56.16209,-48.81694 0,-49.55023 -68.70534,-36.93568 -68.70534,-62.15121 0,-7.49394 6.50463,-14.69029 20.2274,-14.69029 14.65397,0 27.00751,12.54324 27.00751,12.54324 l 22.14844,-23.50446 c 0,0 -16.84797,-18.19335 -48.02593,-18.19335 -35.24457,0 -56.84011,20.19442 -56.84011,45.9919 0,52.02531 68.14032,36.2285 68.14032,63.62023 0,10.67013 -8.92468,16.27232 -20.11438,16.27232 -19.55005,0 -32.08994,-15.82838 -32.08994,-15.82838 z"
                  id="path45961"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccccccccccccc"
                />
                <path
                  style="opacity:1;fill:currentColor;fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 553.68925,151.08932 V 3.77751 h 49.99812 l 34.45645,95.72413 32.69001,-95.72413 h 50.48611 v 147.31181 h -34.2881 V 46.95511 L 648.93396,151.08932 H 624.01479 L 586.70741,45.83644 v 105.25288 z"
                  id="path45963"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="cccccccccccccc"
                />
                <path
                  style="opacity:1;fill:currentColor;fill-opacity:1;stroke:none;stroke-width:0.12699294;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="m 782.95368,3.77781 -61.63374,147.31182 h 38.09788 l 10.97794,-29.20838 h 57.14683 l 11.31527,29.20838 h 54.24236 l 31.01405,-51.75707 32.5097,51.75707 H 1000 L 946.91596,73.37093 993.67764,3.77781 H 952.4471 L 925.18578,49.58208 897.84013,3.77781 h -43.1776 L 902.35434,73.37093 867.83308,126.16975 817.28395,3.77781 Z m 16.42476,39.73242 19.04894,50.43257 h -38.09789 z"
                  id="path45965"
                  inkscape:connector-curvature="0"
                />
              </svg>`,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
